/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Success_Checkfaq1Inputs */

const he_contact_success_checkfaq1 = /** @type {(inputs: Contact_Success_Checkfaq1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`לדף השאלות הנפוצות`)
};

const en_contact_success_checkfaq1 = /** @type {(inputs: Contact_Success_Checkfaq1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check the FAQ`)
};

/**
* | output |
* | --- |
* | "Check the FAQ" |
*
* @param {Contact_Success_Checkfaq1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const contact_success_checkfaq1 = /** @type {((inputs?: Contact_Success_Checkfaq1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Success_Checkfaq1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_contact_success_checkfaq1(inputs)
	return en_contact_success_checkfaq1(inputs)
});
export { contact_success_checkfaq1 as "contact_success_checkFaq" }